(function () {
  'use strict';

  angular
    .module('boxPreview', [])
    .controller('BoxPreviewCtrl', BoxPreviewCtrl);

  BoxPreviewCtrl.$inject = ['$sce', '$scope', 'ServiceHelper', 'gettext', 'boxPreviewErrorService', 'translationService'];

  function BoxPreviewCtrl($sce, $scope, ServiceHelper, gettext, boxPreviewErrorService, translationService) {
    var vm = this;
    var translate = translationService.sprintf;
    var translations = {
      title: translate(gettext('Unable to View Content')),
      message: translate(gettext('This content appears to be blocked by your firewall. Please contact your IT Administrator.'))
    };

    vm.boxId = $scope.currentSlide.boxId;
    vm.pageRange = $scope.currentSlide.pages;

    function onBoxViewerError(value) {
      var scope = $scope.$new();
      scope.contentErrorModal = {
        message: translate(gettext('We have encountered an error loading your content.')),
        redirectToDashboard: true,
        title: translate(gettext('Error Viewing Content'))
      };

      boxPreviewErrorService.showError(scope);
    }
  }
})();
